import { Component, OnInit, ViewChild } from '@angular/core';
import { BrdsqlService } from '../../services/brdsql.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs'
import { ExcelService } from 'src/app/services/excel.service';
import * as XLSX from 'xlsx';
import axios from 'axios';

@Component({
  selector: 'app-finance-ofdata',
  templateUrl: './finance-ofdata.component.html',
  styleUrls: ['./finance-ofdata.component.css']
})
export class FinanceOfdataComponent implements OnInit {

  yearid?: any = []
  financeSummary?: any = []
  financeData?: any = []
  filterbyzone?: any = [];
  supzone?: any = [];
  sub_financeData: Subscription
  @ViewChild('tb_finance', { static: false }) tb_finance: any;

  constructor(
    private brdsql: BrdsqlService,
    private spinner: NgxSpinnerService,
    private excelService:ExcelService,
  ) {
    this.yearid = this.brdsql.yearID
  }

  ngOnInit(): void {
    this.getFinanceData()
  }

  async getFinanceData() {
    this.spinner.show()
    this.sub_financeData = await this.brdsql.getFinanceSummary().subscribe({
      next: (res: any) => {
        this.financeData = res.recordset
        this.filterbyzone = res.recordset
        this.financeSummary = this.financeData.filter((el: { supzone: string; }) => el.supzone == "total-brd");
        this.financeSummary = this.financeSummary[0]
        // setTimeout(() => {
        //   $(this.tb_finance.nativeElement).DataTable();
        // }, 500);
        this.getSupzone()
        this.spinner.hide()
      },
      error: (e) => console.error(e)
    })
  }

  selectbyzone(e: any) {
    let x = e.target.value;
    // console.log('select ' ,x)
    if (x === 'total-brd') {
      this.filterbyzone = this.financeData;
    }
    else {
      this.filterbyzone = this.financeData.filter((el: any) => el.supzone == x);
    }
    console.log('x - ',x,'filterbyzone - ',this.filterbyzone)

  }

  downloadExcel() {
    let dt = new Date().toLocaleString();
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tb_finance.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ข้อมูลสรุปสถานะเกี้ยว' + dt + '.xlsx');
  }

  ngOnDestroy() {
    // คืน Memory
    this.sub_financeData.unsubscribe()
  }

  getSupzone() {

    function uniqByKeepFirst(a, key) {
      let seen = new Set();
      return a.filter(item => {
        let k = key(item);
        return seen.has(k) ? false : seen.add(k);
      });
    }

    function uniqByKeepLast(a, key) {
      return [
        ...new Map(
          a.map(x => [key(x), x])
        ).values()
      ]
    }
    let data = this.financeData
    this.supzone = uniqByKeepFirst(data, it => it.supzone)
    // console.log(uniqByKeepLast(data, it => it.supzone))

  }
  Loaddata1(){
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[dbReport].[dbo].[รายการขอเกี้ยว6667]&w=1=1";
    axios.get(url)
    .then(res =>{
      if(res.data.rowsAffected[0] >= 1){
        let data = (res.data.recordsets[0]);
        this.exportAsXLSX(data,'รายการขอเกี้ยว6667')
        //console.log('data',data);
      }
      this.spinner.hide();
    }).catch(err => { throw(err)})
  }
  exportAsXLSX(data,name):void {
    this.excelService.exportAsExcelFile(data, name);
  }


}
